import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../../helpers/ScrollToTop";
import MainLoader from "../main-loader";
import { DonateModalProvider } from "../donate-modal/donate-modal-context";

const Layout = () => {
  return (
    <DonateModalProvider>
      <Suspense fallback={<MainLoader />}>
        <ScrollToTop />
        <Outlet />
      </Suspense>
    </DonateModalProvider>
  );
};

export default Layout;
